











































































































































































































































































































































































































































































































import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import { ListModel } from "@/shared/models/listModel";
import { DataOptions } from "vuetify";
import { formatOrderbyArray } from "@/shared/sortHelperFunctions";
import { SortableTableHeader } from "@/components/generic-pms-table/SortableTableDirective";
import SortableHeadersTable from "@/components/generic-pms-table/SortableHeadersTable.vue";
import {
  EVisitorGridViewModel,
  EVisitorIntegrationModel,
  EVisitorStatusEnum,
} from "@/shared/models/eVisitor";
import { CityTaxCategory } from "@/shared/models/cityTaxCategory";
import { ArrivalOrganizationType } from "@/shared/models/arrivalOrganizationType";
import { Country } from "@/shared/models/country";
import DateField from "@/components/misc/DateField.vue";
import NoData from "@/components/misc/NoData.vue";
import CheckInOutEditForm from "@/components/reservation-form/check-in/CheckInOutEditForm.vue";
import MultipleGuestsEditForm from "@/components/reservation-form/eVisitor/MultipleGuestsEditForm.vue";
import * as _ from "lodash";
import { IdentificationDocumentType } from "@/shared/models/identificationDocumentType";
import { AxiosRequestConfig } from "axios";
import { getRuleIgnoreAdapter } from "./reservation-form/check-in/CheckInService";
import { Notification } from "@/store/modules/notifications";
import { BrokenRule } from "@/shared/models/apiErrors";
import TableCellUnitTypeDisplay from "@/components/misc/TableCellUnitTypeDisplay.vue";
import {
  EVisitorIntegrationEnum,
  EVisitorIntegrationNameEnum,
} from "@/shared/models/enums.type";
import EVisitorReportDialog from "@/components/eVisitor/EVisitorReportDialog.vue";
import ReservationLinksModal, {
  ReservationLinksEnum,
} from "@/components/reservation-form/ReservationLinksModal.vue";

type EVisitorGridViewModelWithErrors = EVisitorGridViewModel & {
  checkinFeedbackErrors: string[];
  checkoutFeedbackErrors: string[];
};

@Component({
  components: {
    TableCellUnitTypeDisplay,
    SortableHeadersTable,
    DateField,
    NoData,
    CheckInOutEditForm,
    MultipleGuestsEditForm,
    EVisitorReportDialog,
    ReservationLinksModal
  },
})
export default class EVisitorTable extends Vue {
  settingsOpen = false;
  multipleEditOpen = false;

  @Prop() reservationId?: number;
  @Prop() status?: "notCheckedIn" | "checkedIn" | "checkedOut";
  @Prop() tableName?: string;

  // prettier-ignore
  @Action("codebooks/refreshCityTaxCategories")
  refreshPaymentCategories?: () => Promise<void>;
  @Getter("codebooks/cityTaxCategories")
  eVisitorPaymentCategories?: CityTaxCategory[];

  // prettier-ignore
  @Action("codebooks/refresharrivalOrganizationTypes")
  refreshArrivalOrganizationTypes?: () => Promise<void>;
  @Getter("codebooks/arrivalOrganizationTypes")
  eVisitorArrivalOrganizationTypes?: ArrivalOrganizationType[];

  @Action("codebooks/refreshCountries") refreshCountries?: () => Promise<void>;
  @Getter("codebooks/countries") countries?: Country[];

  @Action("codebooks/refreshIdentificationDocumentTypes")
  refreshIdentificationDocumentTypes?: () => Promise<void>;
  @Getter("codebooks/identificationDocumentTypes")
  identificationDocumentTypes?: IdentificationDocumentType[];

  @Getter("appParams/tenantUsesSelfCheckIn") _tenantUsesSelfCheckIn?: boolean;

  dateTo = new Date().toDateString();
  reportType = "month";

  mounted() {
    this.updateDateFieldModel(this.reportType);
  }

  updateDateFieldModel(reportType: string) {
    if (reportType === "month") {
      this.dateFieldModel = new Date(
        new Date().setMonth(new Date().getMonth() - 1)
      )
        .toISOString()
        .slice(0, 7);
      const start = new Date(`${this.dateFieldModel}-01`);
      const end = new Date(start.getFullYear(), start.getMonth() + 1, 0);
      this.endDate = `${end.getFullYear()}-${(end.getMonth() + 1)
        .toString()
        .padStart(2, "0")}-${end.getDate().toString().padStart(2, "0")}`;
    } else if (reportType === "year") {
      this.dateFieldModel = new Date(
        new Date().setFullYear(new Date().getFullYear() - 1, 0, 1)
      )
        .toISOString()
        .slice(0, 7);
      this.endDate = new Date(new Date(this.dateFieldModel).setMonth(11, 31))
        .toISOString()
        .slice(0, 10);
    }
  }

  @Watch("dateFieldModel")
  @Watch("reportyType")
  onDateFieldModelChanged() {
    if (this.reportType === "year") {
      const year = new Date(this.dateFieldModel).getFullYear();
      this.endDate = new Date(year, 11, 32).toISOString().slice(0, 10);
    } else if (this.reportType === "month") {
      const start = new Date(`${this.dateFieldModel}-01`);
      const end = new Date(start.getFullYear(), start.getMonth() + 1, 0);
      this.endDate = `${end.getFullYear()}-${(end.getMonth() + 1)
        .toString()
        .padStart(2, "0")}-${end.getDate().toString().padStart(2, "0")}`;
    }
  }

  dateFieldModel = new Date().toISOString().slice(0, 7);
  endDate = new Date().toISOString().slice(0, 10);
  exportPeriodForTouristBoard = [] as string[];
  exportInProgress = false;

  async created() {
    const promises = [];

    if (
      (this.eVisitorPaymentCategories?.length ?? 0) === 0 &&
      this.refreshPaymentCategories
    ) {
      promises.push(this.refreshPaymentCategories);
    }

    if (
      (this.eVisitorArrivalOrganizationTypes?.length ?? 0) === 0 &&
      this.refreshArrivalOrganizationTypes
    ) {
      promises.push(this.refreshArrivalOrganizationTypes);
    }

    if ((this.countries?.length ?? 0) === 0 && this.refreshCountries) {
      promises.push(this.refreshCountries);
    }

    if (
      this.identificationDocumentTypes &&
      this.identificationDocumentTypes.length == 0
    ) {
      promises.push(this.refreshIdentificationDocumentTypes);
    }

    this.setUpHeaders();

    await Promise.all(promises);
  }

  getCountryName(countryId: number) {
    const country = this.countries?.find((x) => x.id == countryId);
    if (country) {
      return this.$t(
        `Country.Official.${country.isoThreeLetterCode}`
      ).toString();
    }

    return "";
  }

  getIdentificationDocumentType(typeId: number) {
    if (this.identificationDocumentTypes) {
      return (
        this.identificationDocumentTypes.find((x) => x.id == typeId)
          ?.textResourceKey ?? ""
      );
    }
  }

  genders = [
    {
      id: 1,
      text: "Male",
    },
    {
      id: 2,
      text: "Female",
    },
    {
      id: 3,
      text: "Unknown",
    },
  ];
  getGenderText(genderId: number) {
    switch (genderId) {
      case 1:
        return "Male";
      case 2:
        return "Female";
      case 3:
        return "Unknown";
    }
  }

  eVisitorStatuses = [
    {
      text: "NotCheckedIn",
      value: "notCheckedIn",
    },
    {
      text: "CheckedIn",
      value: "checkedIn",
    },
    {
      text: "CheckedOut",
      value: "checkedOut",
    },
  ];
  getStatusText(statusId: number) {
    switch (statusId) {
      case EVisitorStatusEnum.NotCheckedIn:
        return "NotCheckedIn";
      case EVisitorStatusEnum.CheckedIn:
        return "CheckedIn";
      case EVisitorStatusEnum.CheckedOut:
        return "CheckedOut";
    }
  }

  headers: SortableTableHeader[] = [];
  standaloneHeaders: SortableTableHeader[] = [];
  reservationTabHeaders: SortableTableHeader[] = [];

  @Watch("tenantUsesSelfCheckIn", { immediate: true })
  tenantWatch() {
    this.standaloneHeaders = [
      {
        text: "Name",
        value: "customerName",
        active: true,
        default: false,
        class: "resize-header",
        exportHeaders: ["reservationHolderName"],
      },
      {
        text: "Accomodation unit",
        value: "eVisitorFacilityName",
        active: true,
        default: false,
        class: "resize-header",
        exportHeaders: [
          "eVisitorFacilityPropertyName",
          "eVisitorFacilityName",
          "propertyName",
        ],
      },
      {
        text: "EVisitor.ReservationId",
        value: "reservationId",
        active: true,
        default: false,
        class: "resize-header",
        exportHeaders: [],
      },
      {
        text: "Period",
        value: "arrivalDate",
        active: true,
        default: false,
        class: "resize-header",
        exportHeaders: ["arrivalDate", "departureDate"],
      },
      {
        text: "City tax category",
        value: "eVisitorPaymentCategory",
        active: true,
        default: false,
        class: "resize-header",
        exportHeaders: [],
      },
      {
        text: "Arrival organisation type",
        value: "eVisitorArrivalOrganizationType",
        active: true,
        default: false,
        class: "resize-header",
        exportHeaders: [],
      },
      ...(this.tenantUsesSelfCheckIn
        ? [
            {
              text: "Guest.IsSelfCheckIn",
              value: "isSelfCheckIn",
              active: true,
              default: false,
              class: "resize-header",
              exportHeaders: [],
            },
          ]
        : []),
      {
        text: "EVisitor.DVI",
        value: "eVisitorValidationMessages",
        sortable: false,
        active: true,
        default: false,
        class: "resize-header",
        exportHeaders: [],
      },
      {
        text: "Actions",
        value: "actions",
        sortable: false,
        active: true,
        default: true,
        class: "resize-header",
        exportHeaders: [],
      },
    ];

    this.reservationTabHeaders = [
      {
        text: "Name",
        value: "customerName",
        active: true,
        default: false,
        class: "resize-header",
        exportHeaders: [],
      },
      {
        text: "Period",
        value: "arrivalDate",
        active: true,
        default: false,
        class: "resize-header",
        exportHeaders: [],
      },
      {
        text: "VCustomer.identificationDocumentType",
        value: "identificationDocumentTypeId",
        active: true,
        default: false,
        class: "resize-header",
        exportHeaders: [],
      },
      {
        text: "Date of birth",
        value: "dateOfBirth",
        active: true,
        default: false,
        class: "resize-header",
        exportHeaders: [],
      },
      {
        text: "Country of birth",
        value: "countryOfBirthId",
        active: true,
        default: false,
        class: "resize-header",
        exportHeaders: [],
      },
      {
        text: "Gender",
        value: "genderId",
        active: true,
        default: false,
        class: "resize-header",
        exportHeaders: [],
      },
      {
        text: "Country of citizenship",
        value: "citizenshipId",
        active: true,
        default: false,
        class: "resize-header",
        exportHeaders: [],
      },
      {
        text: "Country of residence",
        value: "countryOfResidenceId",
        active: true,
        default: false,
        class: "resize-header",
        exportHeaders: [],
      },
      {
        text: "Arrival organisation type",
        value: "eVisitorArrivalOrganizationType",
        active: true,
        default: false,
        class: "resize-header",
        exportHeaders: [],
      },
      {
        text: "City tax category",
        value: "eVisitorPaymentCategory",
        active: true,
        default: false,
        class: "resize-header",
        exportHeaders: [],
      },
      {
        text: "EVisitor status",
        value: "eVisitorStatusId",
        active: true,
        default: false,
        class: "resize-header",
        exportHeaders: [],
      },
      ...(this.tenantUsesSelfCheckIn
        ? [
            {
              text: "Guest.IsSelfCheckIn",
              value: "isSelfCheckIn",
              active: true,
              default: false,
              class: "resize-header",
              exportHeaders: [],
            },
          ]
        : []),
      {
        text: "EVisitor.DVI",
        value: "eVisitorValidationMessages",
        sortable: false,
        active: true,
        default: false,
        class: "resize-header",
        exportHeaders: [],
      },
      {
        text: "Actions",
        value: "actions",
        sortable: false,
        active: true,
        default: true,
        class: "resize-header",
        exportHeaders: [],
      },
    ];
  }

  @Getter("appParams/tenantEVisitorIntegration")
  eVisitorIntegration?: EVisitorIntegrationModel;
  eVisitorIntegrationEnum = EVisitorIntegrationEnum;
  get eVisitorIntegrationId() {
    return this.eVisitorIntegration?.id ?? EVisitorIntegrationEnum.None;
  }
  get eVisitorIntegrationName() {
    return this.eVisitorIntegration?.name ?? EVisitorIntegrationNameEnum.None;
  }

  setUpHeaders() {
    if (!this.reservationId) {
      this.headers = [...this.standaloneHeaders];
    } else {
      this.headers = [...this.reservationTabHeaders];
    }

    // only available for HR eVisitor
    if (this.eVisitorIntegrationId != EVisitorIntegrationEnum.HR)
      this.headers = this.headers.filter(
        (e) => e.value !== "eVisitorArrivalOrganizationType"
      );
  }

  filters = {
    reservationId: null as number | null,
    arrivalOrDepartureDate: "",
    customerName: "",
    eVisitorFacilityName: "",
    status: "",
    paymentCategoryId: null as number | null,
    arrivalOrganizationTypeId: null as number | null,
    genderId: null as number | null,
    countryOfBirthId: null as number | null,
    citizenshipId: null as number | null,
    countryOfResidenceId: null as number | null,
    dateOfBirth: "",
    filter: "",
  };

  get queryFilters() {
    const filters = {
      ...this.filters,
    };

    filters.reservationId = this.reservationId ?? filters.reservationId;
    filters.status = this.status ?? filters.status;
    filters.filter = this.dashboardFilter;

    return filters;
  }

  get dashboardFilter() {
    return this.$route.query.filter as string;
  }

  @Watch("dashboardFilter")
  dashboardFilterChanged() {
    this.debouncedLoad();
  }

  @Watch("filters", { deep: true })
  watchFilters(val: any, old: any) {
    if (_.isEqual(val, old)) {
      this.options.page = 1;
      this.debouncedLoad();
    }
  }

  get translatedActiveHeaders() {
    return this.headers
      .filter((x) => x.active)
      .map((x) => ({ ...x, text: this.$t(x.text) }));
  }

  options: DataOptions = {
    page: 1,
    itemsPerPage: 15,
    sortBy: ["customerName"],
    sortDesc: [],
    groupBy: [],
    groupDesc: [],
    multiSort: false,
    mustSort: true,
  };

  initLoaded = false;
  @Watch("options", { deep: true })
  watchOptions(fresh: DataOptions, old: DataOptions) {
    if (!this.initLoaded || !_.isEqual(fresh, old)) {
      this.initLoaded = true;
      this.load();
    }
  }

  loading = true;
  saving = false;
  list: ListModel<EVisitorGridViewModelWithErrors> = {
    count: 0,
    result: [],
  };
  selected = [] as EVisitorGridViewModelWithErrors[];

  debouncedLoad = _.debounce(this.load, 500);

  async load(): Promise<ListModel<EVisitorGridViewModelWithErrors>> {
    this.loading = true;
    return this.axios
      .get<ListModel<EVisitorGridViewModel>>(
        "/reservations/QueryEVisitorGuests",
        {
          params: this.queryParams,
        }
      )
      .then((res) => {
        //prettier-ignore
        const oldCheckinFeedbackOrEmpty = (old: EVisitorGridViewModel) => this.list.result
          .find(fresh => fresh.id === old.id)?.checkinFeedbackErrors ?? [];
        //prettier-ignore
        const oldCheckoutFeedbackOrEmpty = (old: EVisitorGridViewModel) => this.list.result
          .find(fresh => fresh.id === old.id)?.checkoutFeedbackErrors ?? [];

        //prettier-ignore
        this.list = {
          result: res.data.result.map((x) => ({
            ...x,
            checkinFeedbackErrors: oldCheckinFeedbackOrEmpty(x),
            checkoutFeedbackErrors: oldCheckoutFeedbackOrEmpty(x)
          })),
          count: res.data.count,
        };

        return this.list;
      })
      .finally(() => {
        this.scrollToTop();
        this.loading = false;
      });
  }

  get queryParams() {
    return {
      $skip: this.options.itemsPerPage * (this.options.page - 1),
      $top: this.options.itemsPerPage,
      $orderby: formatOrderbyArray(
        this.options.sortBy,
        this.options.sortDesc.map((x) => !x)
      ),
      $count: true,
      ...this.queryFilters,
      isFromMainGrid: !this.reservationId,
    };
  }

  scrollToTop() {
    let scrollableWrapper: Element | null = null;

    if (this.$refs.dataTable instanceof Vue) {
      scrollableWrapper = (this.$refs.dataTable as Vue).$el.querySelector(
        ".v-data-table__wrapper"
      );
    } else if (this.$refs.dataTable instanceof Element) {
      scrollableWrapper = (this.$refs.dataTable as Element).querySelector(
        ".v-data-table__wrapper"
      );
    }

    if (scrollableWrapper) {
      scrollableWrapper.scrollTop = 0;
    }
  }

  get checkInDisabled() {
    if (
      !!this.selected &&
      this.selected.length > 0 &&
      !this.selected.some(
        (e) => e.eVisitorStatusId != EVisitorStatusEnum.NotCheckedIn
      )
    ) {
      return false;
    }

    return true;
  }

  get checkOutDisabled() {
    if (
      !!this.selected &&
      this.selected.length > 0 &&
      !this.selected.some(
        (e) => e.eVisitorStatusId != EVisitorStatusEnum.CheckedIn
      )
    ) {
      return false;
    }

    return true;
  }

  get multipleEditDisabled() {
    if (
      this.status != "checkedOut" &&
      !!this.selected &&
      this.selected.length > 1 &&
      !this.selected.some(
        (x) => x.eVisitorStatusId == EVisitorStatusEnum.CheckedOut
      )
    ) {
      const statusOfFirstSelected = this.selected[0].eVisitorStatusId;
      if (
        !this.selected.some((x) => x.eVisitorStatusId != statusOfFirstSelected)
      ) {
        return false;
      }
    }

    return true;
  }

  itemId: number | null = null;
  editFormOpen = false;
  rowDoubleClick(e: MouseEvent, { item }: { item: EVisitorGridViewModel }) {
    this.openItemDetails(item);
  }
  openItemDetails(item: EVisitorGridViewModel) {
    this.itemId = item.id;
    this.editFormOpen = true;
  }

  multipleEditIds = [] as number[];
  multipleEditFormType = "checkIn";
  openMultipleEdit() {
    this.multipleEditIds = this.selected.map((x) => x.id);
    this.multipleEditFormType =
      this.selected[0].eVisitorStatusId == EVisitorStatusEnum.CheckedIn
        ? "checkOut"
        : "checkIn";
    this.multipleEditOpen = true;
  }

  isMarkedFailed(g: EVisitorGridViewModelWithErrors) {
    return (
      !!g.checkinFeedbackErrors.length || !!g.checkoutFeedbackErrors.length
    );
  }

  hasBackendErrors(g: EVisitorGridViewModelWithErrors) {
    return g.eVisitorValidationMessages.some((x) => x !== "");
  }

  async reservationUpdate() {
    try {
      await Vue.axios.post(
        "/reservations/ReservationUpdateForMultipleGuestIds",
        { guestIds: this.selected.map((x) => x.id) }
      );
    } catch {
      // ignore error, axios will handle it
    }
  }

  async checkInSelected() {
    this.saving = true;
    for (const x of this.list.result) {
      x.checkinFeedbackErrors.length = 0;
    }

    for (const guest of this.selected) {
      const eVisitorValidationMessages =
        guest.eVisitorValidationMessages?.filter((x) => x && x !== "") ?? [];

      if (eVisitorValidationMessages.length) {
        guest.checkinFeedbackErrors.push(
          ...eVisitorValidationMessages,
          `EVisitor.CheckIn.IncompleteData`
        );
        continue;
      }

      // revert to default behaviour (don't display toasts or anything)
      let config: AxiosRequestConfig | undefined;
      if (this.axios.defaults.adapter) {
        config = {
          adapter: getRuleIgnoreAdapter(this.axios.defaults.adapter),
        } as AxiosRequestConfig;
      }

      try {
        await this.axios.post(
          `reservations/CheckInMultipleGuestsToEVisitor`,
          {
            guestIds: [guest.id],
          },
          config
        );
      } catch (e) {
        const brokenRules: BrokenRule[] = e.data?.brokenRules ?? [];
        if (brokenRules.length > 0) {
          guest.checkinFeedbackErrors.push(...brokenRules.map((x) => x.name));
        } else {
          guest.checkinFeedbackErrors.push("Error.400");
        }
      }
    }

    await this.reservationUpdate();

    if (
      this.selected.some((x) =>
        x.checkinFeedbackErrors.some(
          (er) => er === "eVistor authentication failed"
        )
      )
    ) {
      this.$store.dispatch("showNotification", {
        color: "error",
        message: this.$t("EVisitor.NotAvailable", {
          eVisitorServiceName: this.eVisitorIntegrationName,
        }).toString(),
        timeout: 8000,
      } as Notification);
    }

    if (
      this.selected.some((x) =>
        x.checkinFeedbackErrors.some(
          (er) => er !== "eVistor authentication failed"
        )
      )
    ) {
      this.$store.dispatch("showNotification", {
        color: "error",
        message: this.$t("EVisitor.CheckIn.CheckErrorDetails", {
          eVisitorServiceName: this.eVisitorIntegrationName,
        }).toString(),
        timeout: 8000,
      } as Notification);
    }

    this.saving = false;
    this.callRefresh();

    this.multipleEditOpen = false;
  }

  async checkOutSelected() {
    this.saving = true;
    for (const x of this.list.result) {
      x.checkoutFeedbackErrors.length = 0;
    }

    for (const guest of this.selected) {
      const eVisitorValidationMessages =
        guest.eVisitorValidationMessages?.filter((x) => x && x !== "") ?? [];

      if (eVisitorValidationMessages.length) {
        guest.checkinFeedbackErrors.push(...eVisitorValidationMessages);
      }

      // revert to default behaviour (don't display toasts or anything)
      let config: AxiosRequestConfig | undefined;
      if (this.axios.defaults.adapter) {
        config = {
          adapter: getRuleIgnoreAdapter(this.axios.defaults.adapter),
        } as AxiosRequestConfig;
      }

      try {
        await this.axios.post(
          `reservations/CheckOutMultipleGuestsToEVisitor`,
          {
            guestIds: [guest.id],
          },
          config
        );
      } catch (e) {
        const brokenRules: BrokenRule[] = e.data?.brokenRules ?? [];
        if (brokenRules.length > 0) {
          guest.checkoutFeedbackErrors.push(...brokenRules.map((x) => x.name));
        } else {
          guest.checkoutFeedbackErrors.push("Error.400");
        }
      }
    }

    await this.reservationUpdate();

    if (this.selected.some((x) => x.checkoutFeedbackErrors.length)) {
      this.$store.dispatch("showNotification", {
        color: "error",
        message: this.$t("EVisitor.CheckOut.CheckErrorDetails", {
          eVisitorServiceName: this.eVisitorIntegrationName,
        }).toString(),
        timeout: 8000,
      } as Notification);
    }

    this.saving = false;
    this.callRefresh();

    this.multipleEditOpen = false;
  }

  callRefresh() {
    this.$emit("refresh");
    if (this.reservationId) {
      this.refresh();
    }
  }

  refresh() {
    this.selected = [];
    this.debouncedLoad();
  }

  resetFeedbackErrorsFor(ids: number[]) {
    this.list?.result
      ?.filter((x) => ids.some((i) => i === x.id))
      ?.forEach((x) => (x.checkinFeedbackErrors = []));
  }

  reason = "";
  reasonTitle = "Cancel check-in on eVisitor reason";
  reasonOpen = false;
  reasonFormValid = false;
  reasonAction = () => Promise.resolve();
  @Ref("reasonForm") reasonForm?: {
    reset: () => void;
    resetValidation: () => void;
    validate: () => boolean;
  };

  get anySelected() {
    return !!this.selected?.length;
  }

  get allSelectedAreCheckedIn() {
    return (this.selected ?? []).every(
      (x) => x.eVisitorStatusId === EVisitorStatusEnum.CheckedIn
    );
  }
  get anySelectedIsCheckedIn() {
    return (this.selected ?? []).some(
      (x) => x.eVisitorStatusId === EVisitorStatusEnum.CheckedIn
    );
  }

  get allSelectedAreCheckedOut() {
    return (this.selected ?? []).every(
      (x) => x.eVisitorStatusId === EVisitorStatusEnum.CheckedOut
    );
  }

  revertEVisitorCheckIn() {
    this.reasonForm?.resetValidation();
    this.reason = "";
    this.reasonTitle = "Cancel check-in on eVisitor reason";
    this.reasonOpen = true;
    this.reasonAction = this.revertEVisitorCheckInConfirm;
  }
  async revertEVisitorCheckInConfirm() {
    this.reasonOpen = false;
    await this.revert(this.reason, "reservations/cancelEVisitorGuestCheckIn");
  }
  revertEVisitorCheckOut() {
    this.reasonForm?.resetValidation();
    this.reason = "";
    this.reasonTitle = "Cancel check-out on eVisitor reason";
    this.reasonOpen = true;
    this.reasonAction = this.revertEVisitorCheckOutConfirm;
  }
  async revertEVisitorCheckOutConfirm() {
    this.reasonOpen = false;
    await this.revert(this.reason, "reservations/cancelEVisitorGuestCheckOut");
  }

  async revert(reason: string, action: string) {
    this.saving = true;
    for (const x of this.list.result) {
      x.checkinFeedbackErrors.length = 0;
    }

    for (const guest of this.selected) {
      const eVisitorValidationMessages =
        guest.eVisitorValidationMessages?.filter((x) => x && x !== "") ?? [];

      if (eVisitorValidationMessages.length) {
        guest.checkinFeedbackErrors.push(
          ...eVisitorValidationMessages,
          `EVisitor.CheckIn.IncompleteData`
        );
        continue;
      }

      // revert to default behaviour (don't display toasts or anything)
      let config: AxiosRequestConfig | undefined;
      if (this.axios.defaults.adapter) {
        config = {
          adapter: getRuleIgnoreAdapter(this.axios.defaults.adapter),
        } as AxiosRequestConfig;
      }

      try {
        await this.axios.post(
          action,
          {
            id: guest.id,
            reason: reason,
          },
          config
        );
      } catch (e) {
        const brokenRules: BrokenRule[] = e.data?.brokenRules ?? [];
        if (brokenRules.length > 0) {
          guest.checkinFeedbackErrors.push(...brokenRules.map((x) => x.name));
        } else {
          guest.checkinFeedbackErrors.push("Error.400");
        }
      }
    }

    await this.reservationUpdate();

    if (this.selected.some((x) => x.checkinFeedbackErrors.length)) {
      this.$store.dispatch("showNotification", {
        color: "error",
        message: this.$t("EVisitor.CheckIn.CheckErrorDetails", {
          eVisitorServiceName: this.eVisitorIntegrationName,
        }).toString(),
        timeout: 8000,
      } as Notification);
    }

    this.saving = false;
    this.callRefresh();
  }

  reservationLinksModalOpen = false;
  reservationLinksEnum = ReservationLinksEnum;

  get tenantUsesSelfCheckIn() {
    return this._tenantUsesSelfCheckIn ?? false;
  }

  get showSelfCheckInButton() {
    return !!this.reservationId && this.tenantUsesSelfCheckIn;
  }

  copyLink(link: string) {
    navigator.clipboard.writeText(link);

    this.$store.dispatch("showNotification", {
      color: "success",
      message: this.$t("LinkCopiedToClipboard"),
      timeout: 5000,
    });
  }

  get rules() {
    const required = (value: any) => !!value || this.$t("Validation.Required");
    return {
      reason: [
        (v: string) => {
          const r = required(v);
          return this.reasonOpen ? r : true;
        },
      ],
    };
  }
}
